import type { AuthTokens } from './auth.types'

const TOKEN_KEY = 'auth_token'
const REFRESH_TOKEN_KEY = 'auth_refresh_token'
const EXPIRES_AT_KEY = 'auth_expires_at'

function isLocalStorageAvailable(): boolean {
  if (typeof window === 'undefined') return false
  try {
    const testKey = '__test__'
    window.localStorage.setItem(testKey, testKey)
    window.localStorage.removeItem(testKey)
    return true
  } catch {
    return false
  }
}

export const tokenService = {
  getToken(): string | null {
    if (!isLocalStorageAvailable()) return null
    return localStorage.getItem(TOKEN_KEY)
  },

  getRefreshToken(): string | null {
    if (!isLocalStorageAvailable()) return null
    return localStorage.getItem(REFRESH_TOKEN_KEY)
  },

  getExpiresAt(): number | null {
    if (!isLocalStorageAvailable()) return null
    const expiresAt = localStorage.getItem(EXPIRES_AT_KEY)
    return expiresAt ? parseInt(expiresAt, 10) : null
  },

  setTokens(tokens: AuthTokens): void {
    if (!isLocalStorageAvailable()) return

    localStorage.setItem(TOKEN_KEY, tokens.accessToken)

    if (tokens.refreshToken) {
      localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refreshToken)
    }

    if (tokens.expiresAt) {
      localStorage.setItem(EXPIRES_AT_KEY, tokens.expiresAt.toString())
    }
  },

  clearTokens(): void {
    if (!isLocalStorageAvailable()) return

    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(REFRESH_TOKEN_KEY)
    localStorage.removeItem(EXPIRES_AT_KEY)
  },

  isTokenExpired(): boolean {
    const expiresAt = this.getExpiresAt()
    if (!expiresAt) return false

    const bufferSeconds = 60
    return Date.now() >= (expiresAt - bufferSeconds) * 1000
  },

  hasValidToken(): boolean {
    const token = this.getToken()
    if (!token) return false
    return !this.isTokenExpired()
  },
}
